import moment from 'moment-timezone'

import type {MonthlyTrendsKpisDto, KpiTrendChartData} from '../types'

export const mapToKpiTrendChartData = (data?: MonthlyTrendsKpisDto): KpiTrendChartData => {
  const chartData: KpiTrendChartData = {labels: [], data: []}

  data?.kpis.forEach((item) => {
    const label = moment.utc([item.yearMonth.year, item.yearMonth.month - 1]).toISOString()
    chartData.labels.push(label)
    chartData.data.push(item.value.actual ?? 0)
  })

  return chartData
}
